import ReactDOM from "react-dom/client";
import "lib-flexible";
import "./index.less";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<App />);
